import { TRACKING_WORD_DELIMITER } from "../analytics/constants";
export const formatCategoryBreadcrumbs = breadcrumbs =>
  breadcrumbs
    .slice(1)
    .filter(breadcrumb => breadcrumb.Label !== undefined)
    .map(breadcrumb => breadcrumb.Label)
    .join(TRACKING_WORD_DELIMITER)
    .toLowerCase();

export const buildItemsDataTemplate = (product, index) => {
  const template = {
    item_name: product.description,
    priceLocalCurrency: product.priceLocalCurrency,
    item_brand: product.brandName,
    item_variant: product.colour,
    itemType: "Product",
    quantity: 1,
    index: index + 1,
    google_business_vertical: "retail"
  };

  if (product.id) {
    template.productId = product.id.toString();
  } else if (product.productId) {
    template.productId = product.productId.toString();
  }

  if (product.productCode) {
    template.productCode = product.productCode.toString();
  }

  return template;
};
